import { TipTapContent, toJSONContent } from '@lessonup/pins-shared';
import React from 'react';
import { TiptapViewer } from './TipTapViewer';

interface ParsedTextTipTapViewerProps {
  content?: TipTapContent | string;
}

export const ParsedTextTipTapViewer: React.FC<ParsedTextTipTapViewerProps> = ({ content }) => {
  const parsedAnswer = content ? toJSONContent(content) : undefined;
  return <TiptapViewer content={parsedAnswer} />;
};
